(function () {
    var root = document.getElementById('md-acc-addr-app');
    if (!root || typeof mdMealPrep === 'undefined') {
        return;
    }
    var M = window.MDMeals;
    if (!M || !M.api) {
        return;
    }

    var loading = document.getElementById('md-acc-addr-loading');
    var errEl = document.getElementById('md-acc-addr-error');
    var statusEl = document.getElementById('md-acc-addr-status');
    var listEl = document.getElementById('md-acc-addr-list');
    var editor = document.getElementById('md-acc-addr-editor');
    var addBtn = document.getElementById('md-acc-addr-add');
    var saveBtn = document.getElementById('md-acc-addr-save');
    var cancelBtn = document.getElementById('md-acc-addr-cancel');
    var locHidden = document.getElementById('md-acc-addr-location');
    var locSearch = document.getElementById('md-acc-addr-loc-search');
    var locList = document.getElementById('md-acc-addr-loc-list');
    var locClear = document.getElementById('md-acc-addr-loc-clear');
    var fromWelcome = (root.getAttribute('data-from') || '') === 'welcome';

    var locationsCache = [];
    var addresses = [];
    var initialCount = 0;
    var editIndex = -1;
    var editKind = 'location';
    var comboActiveIndex = -1;
    var comboFiltered = [];
    var listCloseTimer = null;

    function esc(s) {
        return M.esc(String(s == null ? '' : s));
    }
    function showErr(m) {
        if (!errEl) return;
        if (m) {
            errEl.textContent = m;
            errEl.hidden = false;
        } else {
            errEl.textContent = '';
            errEl.hidden = true;
        }
    }
    function showStatus(m) {
        if (statusEl) statusEl.textContent = m || '';
    }
    function welcomeRedirect() {
        var accountUrl = (mdMealPrep && mdMealPrep.accountUrl) || '/account/';
        try {
            var u = new URL(accountUrl, window.location.origin);
            u.pathname = u.pathname.replace(/\/?$/, '/') + 'welcome/';
            u.searchParams.set('saved', 'delivery');
            window.location.href = u.toString();
        } catch (e) {
            window.location.href = accountUrl + 'welcome/?saved=delivery';
        }
    }

    function locationLabel(loc) {
        return loc.title + (loc.address ? ' — ' + loc.address : '');
    }

    function findLocation(id) {
        var found = null;
        var nid = parseInt(id, 10) || 0;
        (locationsCache || []).forEach(function (L) {
            if (L.id === nid) found = L;
        });
        return found;
    }

    function locationName(id) {
        var found = findLocation(id);
        return found ? locationLabel(found) : 'Approved location';
    }

    function setComboExpanded(on) {
        if (locSearch) locSearch.setAttribute('aria-expanded', on ? 'true' : 'false');
    }

    function syncActiveDescendant() {
        if (!locSearch) return;
        if (comboActiveIndex >= 0 && comboFiltered[comboActiveIndex]) {
            locSearch.setAttribute('aria-activedescendant', 'md-acc-addr-loc-opt-' + comboFiltered[comboActiveIndex].id);
        } else {
            locSearch.removeAttribute('aria-activedescendant');
        }
    }

    function renderComboList() {
        if (!locList) return;
        locList.innerHTML = '';
        comboFiltered.forEach(function (L, i) {
            var li = document.createElement('li');
            li.setAttribute('role', 'option');
            li.id = 'md-acc-addr-loc-opt-' + L.id;
            li.textContent = locationLabel(L);
            li.dataset.id = String(L.id);
            if (i === comboActiveIndex) {
                li.setAttribute('aria-selected', 'true');
            }
            li.addEventListener('mousedown', function (ev) {
                ev.preventDefault();
                selectLocationById(L.id);
            });
            locList.appendChild(li);
        });
        syncActiveDescendant();
    }

    function filterCombo() {
        var q = (locSearch && locSearch.value || '').trim().toLowerCase();
        comboFiltered = (locationsCache || []).filter(function (L) {
            if (!q) return true;
            var hay = (L.title + ' ' + (L.address || '')).toLowerCase();
            return hay.indexOf(q) !== -1;
        });
        comboActiveIndex = comboFiltered.length ? 0 : -1;
        renderComboList();
    }

    function openComboList() {
        if (!locSearch || editKind !== 'location') return;
        filterCombo();
        if (locList) locList.hidden = comboFiltered.length === 0;
        setComboExpanded(comboFiltered.length > 0);
    }

    function closeComboList() {
        if (locList) locList.hidden = true;
        comboActiveIndex = -1;
        setComboExpanded(false);
        syncActiveDescendant();
    }

    function scheduleCloseCombo() {
        if (listCloseTimer) clearTimeout(listCloseTimer);
        listCloseTimer = setTimeout(function () {
            listCloseTimer = null;
            closeComboList();
        }, 180);
    }

    function cancelCloseCombo() {
        if (listCloseTimer) {
            clearTimeout(listCloseTimer);
            listCloseTimer = null;
        }
    }

    function selectLocationById(id) {
        if (!locHidden || !locSearch) return;
        var L = findLocation(id);
        if (!L) return;
        locHidden.value = String(L.id);
        locSearch.value = locationLabel(L);
        if (locClear) locClear.hidden = false;
        closeComboList();
    }

    function clearComboSelection() {
        if (locHidden) locHidden.value = '';
        if (locSearch) locSearch.value = '';
        if (locClear) locClear.hidden = true;
        closeComboList();
    }

    function syncComboFromAddress(a) {
        if (!locHidden || !locSearch) return;
        if (a && a.kind === 'location' && a.location_id) {
            locHidden.value = String(a.location_id);
            var L = findLocation(a.location_id);
            locSearch.value = L ? locationLabel(L) : locationName(a.location_id);
            if (locClear) locClear.hidden = !L;
        } else {
            clearComboSelection();
        }
    }

    function renderAddresses() {
        if (!listEl) return;
        if (!addresses.length) {
            listEl.innerHTML = '';
            return;
        }
        var h = '';
        addresses.forEach(function (a, ix) {
            var head = a.label || (a.kind === 'custom' ? 'Custom address' : locationName(a.location_id));
            var kindLabel = a.kind === 'custom' ? 'Custom' : 'Approved location';
            var detail = '';
            if (a.kind === 'location') {
                detail = locationName(a.location_id);
                if (a.unit) detail += ' · Unit ' + a.unit;
            } else {
                var parts = [];
                if (a.address_line1) parts.push(a.address_line1);
                if (a.address_line2) parts.push(a.address_line2);
                var cityRow = [a.city, a.state].filter(Boolean).join(', ');
                if (cityRow) parts.push(cityRow + (a.zip ? ' ' + a.zip : ''));
                if (a.unit) parts.push('Unit ' + a.unit);
                detail = parts.join(' · ');
            }
            if (a.delivery_notes) detail += (detail ? ' · ' : '') + 'Notes: ' + a.delivery_notes;
            h +=
                '<li class="md-profile-address' + (a.is_default ? ' is-default' : '') + '" data-index="' + ix + '">' +
                '<div class="md-profile-address__head">' +
                '<span>' + esc(head) + '</span>' +
                '<span class="md-profile-address__kind">' + esc(kindLabel) + '</span>' +
                (a.is_default ? '<span class="md-profile-address__default-badge">Default</span>' : '') +
                '</div>' +
                '<div class="md-profile-address__actions">' +
                (a.is_default ? '' : '<button type="button" class="btn btn-primary-outline btn-xs" data-md-addr-act="default" data-i="' + ix + '">Set default</button>') +
                ' <button type="button" class="btn btn-primary-outline btn-xs" data-md-addr-act="edit" data-i="' + ix + '">Edit</button>' +
                ' <button type="button" class="btn btn-primary-outline btn-xs" data-md-addr-act="delete" data-i="' + ix + '">Delete</button>' +
                '</div>' +
                '<p class="md-profile-address__detail">' + esc(detail) + '</p>' +
                '</li>';
        });
        listEl.innerHTML = h;
    }

    function setEditorMode(kind) {
        editKind = kind === 'custom' ? 'custom' : 'location';
        if (!editor) return;
        editor.querySelectorAll('[data-md-addr-mode]').forEach(function (el) {
            el.hidden = el.getAttribute('data-md-addr-mode') !== editKind;
        });
        if (editKind === 'location') {
            openComboList();
        } else {
            closeComboList();
        }
    }

    function updateEditorChrome() {
        if (!editor) return;
        var open = !editor.hidden;
        if (addBtn) addBtn.hidden = open || addresses.length === 0;
        if (cancelBtn) {
            cancelBtn.hidden = !open || !(editIndex >= 0 || addresses.length > 0);
        }
        if (saveBtn) saveBtn.textContent = fromWelcome ? 'Save and continue' : 'Save address';
    }

    function openEditor(index) {
        if (!editor) return;
        cancelCloseCombo();
        editIndex = typeof index === 'number' ? index : -1;
        var a = editIndex >= 0 ? addresses[editIndex] : null;
        setEditorMode(a ? a.kind : 'location');
        var pick = function (id, val) {
            var el = document.getElementById(id);
            if (el) el.value = val == null ? '' : String(val);
        };
        var check = function (id, val) {
            var el = document.getElementById(id);
            if (el) el.checked = !!val;
        };
        if (a && a.kind === 'location') {
            pick('md-acc-addr-location', a.location_id);
            syncComboFromAddress(a);
        } else {
            pick('md-acc-addr-location', '');
            clearComboSelection();
        }
        pick('md-acc-addr-line1', a ? a.address_line1 : '');
        pick('md-acc-addr-line2', a ? a.address_line2 : '');
        pick('md-acc-addr-city', a ? a.city : '');
        pick('md-acc-addr-state', a ? a.state : '');
        pick('md-acc-addr-zip', a ? a.zip : '');
        pick('md-acc-addr-label', a ? a.label : '');
        pick('md-acc-addr-unit', a ? a.unit : '');
        pick('md-acc-addr-notes', a ? a.delivery_notes : '');
        check('md-acc-addr-default', a ? a.is_default : addresses.length === 0);
        editor.hidden = false;
        closeComboList();
        updateEditorChrome();
    }

    function closeEditor() {
        if (editor) editor.hidden = true;
        editIndex = -1;
        closeComboList();
        updateEditorChrome();
    }

    function readEditor() {
        var v = function (id) {
            var el = document.getElementById(id);
            return el ? String(el.value || '').trim() : '';
        };
        var bool = function (id) {
            var el = document.getElementById(id);
            return el ? !!el.checked : false;
        };
        var row = {
            kind: editKind,
            label: v('md-acc-addr-label'),
            unit: v('md-acc-addr-unit'),
            delivery_notes: v('md-acc-addr-notes'),
            is_default: bool('md-acc-addr-default'),
        };
        if (editKind === 'location') {
            row.location_id = parseInt(v('md-acc-addr-location'), 10) || 0;
            if (!row.location_id) {
                return { error: 'Pick a location from the list, or add a custom address.' };
            }
        } else {
            row.address_line1 = v('md-acc-addr-line1');
            row.address_line2 = v('md-acc-addr-line2');
            row.city = v('md-acc-addr-city');
            row.state = v('md-acc-addr-state');
            row.zip = v('md-acc-addr-zip');
            if (!row.address_line1 || !row.city || !row.state || !row.zip) {
                return { error: 'Custom addresses need street, city, state, and ZIP.' };
            }
        }
        return { row: row };
    }

    function summaryRedirect() {
        var accountUrl = (mdMealPrep && mdMealPrep.accountUrl) || '/account/';
        window.location.href = accountUrl;
    }

    function persist() {
        return M.api('profile', {
            method: 'POST',
            body: { delivery_addresses: addresses },
        })
            .then(function (d) {
                applyProfile(d);
                showStatus('Saved.');
                setTimeout(function () {
                    showStatus('');
                }, 3000);
                var doWelcome = fromWelcome && initialCount === 0 && addresses.length > 0;
                if (addresses.length === 0) {
                    openEditor(-1);
                }
                if (doWelcome) {
                    var st = d && d.profile_status;
                    if (st && st.complete) {
                        summaryRedirect();
                    } else {
                        welcomeRedirect();
                    }
                }
            })
            .catch(function (e) {
                showErr(e.message || String(e));
            });
    }

    function applyProfile(d) {
        if (!d) return;
        locationsCache = d.locations || [];
        addresses = (d.delivery_addresses || []).map(function (a) {
            return {
                kind: a.kind || 'location',
                label: a.label || '',
                location_id: a.location_id || 0,
                address_line1: a.address_line1 || '',
                address_line2: a.address_line2 || '',
                city: a.city || '',
                state: a.state || '',
                zip: a.zip || '',
                unit: a.unit || '',
                delivery_notes: a.delivery_notes || '',
                is_default: !!a.is_default,
            };
        });
        renderAddresses();
    }

    function load() {
        showErr('');
        M.api('profile', { method: 'GET' })
            .then(function (d) {
                if (loading) {
                    loading.hidden = true;
                    loading.setAttribute('aria-busy', 'false');
                }
                applyProfile(d);
                initialCount = addresses.length;
                if (fromWelcome || addresses.length === 0) {
                    openEditor(-1);
                } else {
                    updateEditorChrome();
                }
            })
            .catch(function (e) {
                if (loading) loading.innerHTML = '<p class="md-meals-error">' + esc(e.message || e) + '</p>';
            });
    }

    if (addBtn) addBtn.addEventListener('click', function () { openEditor(-1); });
    if (cancelBtn) {
        cancelBtn.addEventListener('click', function () {
            if (addresses.length === 0 && editIndex < 0) return;
            closeEditor();
        });
    }
    if (editor) {
        editor.querySelectorAll('[data-md-addr-mode-switch]').forEach(function (b) {
            b.addEventListener('click', function () {
                setEditorMode(b.getAttribute('data-md-addr-mode-switch'));
            });
        });
    }
    if (locSearch) {
        locSearch.addEventListener('focus', function () {
            cancelCloseCombo();
            if (editKind === 'location') openComboList();
        });
        locSearch.addEventListener('input', function () {
            if (locHidden) locHidden.value = '';
            if (locClear) locClear.hidden = true;
            if (editKind === 'location') openComboList();
        });
        locSearch.addEventListener('blur', function () {
            scheduleCloseCombo();
        });
        locSearch.addEventListener('keydown', function (ev) {
            if (editKind !== 'location') return;
            if (ev.key === 'ArrowDown') {
                ev.preventDefault();
                cancelCloseCombo();
                if (locList && locList.hidden) openComboList();
                if (comboFiltered.length) {
                    comboActiveIndex = Math.min(comboFiltered.length - 1, comboActiveIndex + 1);
                    if (comboActiveIndex < 0) comboActiveIndex = 0;
                    renderComboList();
                }
            } else if (ev.key === 'ArrowUp') {
                ev.preventDefault();
                cancelCloseCombo();
                if (comboFiltered.length) {
                    comboActiveIndex = Math.max(0, comboActiveIndex - 1);
                    renderComboList();
                }
            } else if (ev.key === 'Enter') {
                if (!locList || locList.hidden) return;
                if (comboActiveIndex >= 0 && comboFiltered[comboActiveIndex]) {
                    ev.preventDefault();
                    selectLocationById(comboFiltered[comboActiveIndex].id);
                }
            } else if (ev.key === 'Escape') {
                ev.preventDefault();
                closeComboList();
            }
        });
    }
    if (locList) {
        locList.addEventListener('mouseenter', cancelCloseCombo);
    }
    if (locClear) {
        locClear.addEventListener('mousedown', function (ev) {
            ev.preventDefault();
        });
        locClear.addEventListener('click', function () {
            clearComboSelection();
            if (locSearch) locSearch.focus();
        });
    }
    if (saveBtn) {
        saveBtn.addEventListener('click', function () {
            showErr('');
            var r = readEditor();
            if (r.error) {
                showErr(r.error);
                return;
            }
            if (r.row.is_default) {
                addresses.forEach(function (a) { a.is_default = false; });
            }
            if (editIndex >= 0 && editIndex < addresses.length) {
                addresses[editIndex] = r.row;
            } else {
                if (addresses.length === 0) r.row.is_default = true;
                addresses.push(r.row);
            }
            renderAddresses();
            closeEditor();
            persist();
        });
    }
    if (listEl) {
        listEl.addEventListener('click', function (ev) {
            var btn = ev.target.closest && ev.target.closest('[data-md-addr-act]');
            if (!btn) return;
            var act = btn.getAttribute('data-md-addr-act');
            var i = parseInt(btn.getAttribute('data-i'), 10);
            if (isNaN(i) || i < 0 || i >= addresses.length) return;
            if (act === 'edit') {
                openEditor(i);
            } else if (act === 'delete') {
                if (!window.confirm('Delete this saved address?')) return;
                var wasDefault = !!addresses[i].is_default;
                addresses.splice(i, 1);
                if (wasDefault && addresses.length) addresses[0].is_default = true;
                renderAddresses();
                persist();
            } else if (act === 'default') {
                addresses.forEach(function (a, ix) { a.is_default = ix === i; });
                renderAddresses();
                persist();
            }
        });
    }

    load();
})();
